import { DatePipe } from '@angular/common';

export class EmployeeModel {
      empyeeId: number;
      lastName: string;
      civility:string;
      firstName:string;
      gender:string;
      dateOfBirth:DatePipe;
      department:number;
      workPhone:number;
      workFax:number;
      mob1:number;
      mob2:number;
      email:string;
      partnerId:number;
      partnerType:number;
      persoVaFirstnameEn: string;
      gendeCode: string;
      civilCode:number;
      persoVaLastnameEn:string;
      deptmId:number;
      persoVaWorkPhone:number;
      persoVaWorkFax: number;
      persoVaMobilePhone1: number;
      persoVaMobilePhone2: number
      persoVaEmail: string;
      maritalname: string;
      persoDtBirthDate:string;
      joinigndate:string;
      employeeid: string;
      persoVaThirdName: string;
      persoVaSecondName: string;
      empyeeVaFunction: string;
      persoVaEmail2: string;

    
}